import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw
} from "lucide-react";



export function Players() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const load = () => api.get("/admin/players/linked").then(({ data }) => setRows(data.players || [])).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);
  const unlink = async (r) => {
    if (!window.confirm(`Unlink ${r.player_name} from ${r.server_name}?`)) return;
    try {
      await api.delete("/admin/players/unlink", { data: { user_id: r.user_id, server_name: r.server_name } });
      toast.success("Unlinked");
      load();
    } catch (e) { toast.error(apiError(e)); }
  };
  const filtered = rows.filter((r) => !q || r.player_name?.toLowerCase().includes(q.toLowerCase()) || r.server_name?.toLowerCase().includes(q.toLowerCase()));
  if (loading) return <Loader />;
  return (
    <div className="fade-up">
      <input className="input mb-4" placeholder="Search by player or server…" value={q} onChange={(e) => setQ(e.target.value)} data-testid="players-search" />
      {/* Phones: one card per row. A 5-column table at 390px means a
          two-finger side-scroll just to reach the Unlink button. */}
      <ul className="glass-card divide-y divide-white/5 sm:hidden" data-testid="players-list-mobile">
        {filtered.map((r) => (
          <li key={`m-${r.user_id}-${r.server_name}`} className="p-3 space-y-1.5">
            <div className="flex items-center justify-between gap-2">
              <span className="font-medium truncate">{r.player_name}</span>
              <button onClick={() => unlink(r)} className="btn btn-sm btn-danger shrink-0" data-testid={`unlink-m-${r.user_id}-button`}>Unlink</button>
            </div>
            <div className="flex items-center gap-2 text-xs text-[var(--muted)]">
              <span className="badge text-[var(--muted)] border-white/10 shrink-0">{r.source}</span>
              <span className="truncate">{r.server_name}</span>
            </div>
            <div className="font-mono text-[10px] text-[var(--muted)] truncate">{r.user_id}</div>
          </li>
        ))}
        {filtered.length === 0 && <li className="p-6 text-center text-[var(--muted)]">No matches.</li>}
      </ul>

      <div className="glass-card overflow-x-auto hidden sm:block">
        <table className="w-full text-sm" data-testid="players-table">
          <thead className="text-[10px] uppercase tracking-wider text-[var(--muted)]">
            <tr><th className="text-left p-3">Source</th><th className="text-left p-3">User ID</th><th className="text-left p-3">Server</th><th className="text-left p-3">Player</th><th className="p-3"></th></tr>
          </thead>
          <tbody>
            {filtered.map((r) => (
              <tr key={`${r.user_id}-${r.server_name}`} className="border-t border-white/5">
                <td className="p-3"><span className="badge text-[var(--muted)] border-white/10">{r.source}</span></td>
                <td className="p-3 font-mono text-[11px] truncate max-w-[140px]">{r.user_id}</td>
                <td className="p-3">{r.server_name}</td>
                <td className="p-3">{r.player_name}</td>
                <td className="p-3 text-right"><button onClick={() => unlink(r)} className="btn btn-sm btn-danger" data-testid={`unlink-${r.user_id}-button`}>Unlink</button></td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-[var(--muted)]">No matches.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
